import { useSyncExternalStore } from 'react';

/** @typedef {{ isOpen: boolean, x: number, y: number, event: import('@fullcalendar/core').EventApi | null, calendar: import('@fullcalendar/core').CalendarApi | null }} EventContextMenuState */

/** @type {EventContextMenuState} */
let state = {
  isOpen: false,
  x: 0,
  y: 0,
  event: null,
  calendar: null,
};

/** @type {Set<() => void>} */
const listeners = new Set();

/**
 * Renvoie le state actuel.
 * @returns {EventContextMenuState}
 */
function getSnapshot() {
  return state;
}

/**
 * S'abonne à un listener.
 * @param {() => void} listener
 * @returns {() => void}
 */
function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/**
 * Notifie les listeners que le state a changé.
 */
function emitChange() {
  listeners.forEach((listener) => listener());
}

/**
 * Ouvre le menu contextuel à la position donnée avec l'événement et le calendrier.
 * @param {number} x
 * @param {number} y
 * @param {import('@fullcalendar/core').EventApi} event
 * @param {import('@fullcalendar/core').CalendarApi} calendar
 */
export function openContextMenu(x, y, event, calendar) {
  state = {
    isOpen: true,
    x,
    y,
    event,
    calendar,
  };
  emitChange();
}

/**
 * Ferme le menu contextuel.
 */
export function closeContextMenu() {
  state = {
    isOpen: false,
    x: 0,
    y: 0,
    event: null,
    calendar: null,
  };
  emitChange();
}

/**
 * Hook pour s'abonner au state du menu contextuel (affichage uniquement).
 * Seul le composant qui utilise ce hook re-render à l'ouverture/fermeture.
 * @returns {EventContextMenuState & { closeContextMenu: () => void }}
 */
export function useEventContextMenu() {
  // getServerSnapshot (3e arg) = getSnapshot : même état initial côté serveur, donc on passe deux fois la même fonction
  const snapshot = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return {
    ...snapshot,
    closeContextMenu,
  };
}
